import { styled } from 'styled-components'

export const StyledDigitSlot = styled.span`
  display: inline-block;
  width: 0.625em;
  text-align: center;
`
